import { deliveryRequestStrings } from '@data/deliveryRequest';
import { BaseChangeLog } from '@models/next/ChangeLog';

export const getChangeLogDefaultDetail = (baseChangeLog: BaseChangeLog) => {
  if (baseChangeLog.edited_field.startsWith('booking_inquiry.owner_company.')) {
    return `会員情報の変更`;
  } else if (baseChangeLog.edited_field.startsWith('booking_inquiry.')) {
    return `予約内容の変更`;
  } else if (baseChangeLog.edited_field.startsWith('delivery_request.')) {
    return `${deliveryRequestStrings.deliveryRequestFile}の変更`;
  } else if (baseChangeLog.edited_field.startsWith('pre_alert.')) {
    return `Pre Alertの変更`;
  }
};
